<template>
  <div class="app" v-title data-title="富林印迹-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="2" />
    <div class="yj-banner rel">
      <img src="@/assets/images/wz-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/wanzhuan/index" class="f16 fw">玩转富林</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/wanzhuan/gonglue" class="f16 fw">游记攻略</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">玩转富林</div>
        <div class="f17 ls3">Explore Guangfulin</div>
      </div>
      <!-- <div class="yj-nav wp100">
        <div class="yj-nav-item df align_center justify_center" v-if="seriesList && seriesList.length > 0">
          <div class="yj-nav-box" style="cursor:pointer"
              v-for="item in seriesList" :key="item.Id" :class="seriesSelect == item.Code ? 'active' : ''"
              @click="handleSeriesClick(item)" >
            <div class="yj-nav-link db f24">{{ item.Name }}</div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="wz-gonglue mt30 pb100 w1200 auto">
      <div class="df justify_between">
        <div class="wz-gonglue-item w1000">
          <div class="wz-gonglue-box" v-for="item in list" :key="item.Id">
            <router-link :to="`/pages/wanzhuan/gonglue-view?id=${item.Id}&series=${item.Tag.Series}`" class="df align_center wz-gonglue-link">
              <img v-if="item.Photo" :src="item.Photo + '!/both/280x168'" class="db mr20" alt="" />
              <div class="wz-gonglue-text f1">
                <div class="f24 line_clamp1 b">{{ item.Name }}</div>
                <div class="f16 line_clamp3 mt15">{{ item.Intro | clearHtml}}</div>
                <div class="df align_center justify_between mt15 op90">
                  <div class="f14" v-if="item.Source">来源：{{ item.Source }}</div>
                  <div class="f14" v-if="item.PublishTime">{{ item.PublishTime }}</div>
                </div>
              </div>
            </router-link>
          </div>
          <!-- <div class="wz-gonglue-box" v-for="(index,item) in 10" :key="index">
            <router-link to="/gonglue-view" class="df align_center wz-gonglue-link">
              <img src="@/assets/images/wz-p1.png" class="db mr20" alt="" />
              <div class="wz-gonglue-text f1">
                <div class="f24 line_clamp1 b">寻梦广富林：穿越时光的文化之旅</div>
                <div class="f16 line_clamp3 mt15">在繁华都市的边缘，有一处静谧而神秘的地方——广富林遗址公园。怀揣着对历史的敬畏与好奇，我踏上了这片充满故事的土地。踏入公园，仿佛进入了一个时光隧道。古老的建筑错落有致地分布在绿树丛中，散发着古朴的气息。沿着蜿蜒的小径前行，脚下的石板路仿佛在诉说着往昔的繁华。微风拂过，树叶沙沙作响，像是在低声吟唱着古老的歌谣。</div>
                <div class="df align_center justify_between mt15 op90">
                  <div class="f14">来源：公众号</div>
                  <div class="f14">2025-06-14 10:15</div>
                </div>
              </div>
            </router-link>
          </div> -->

          <div class="pages df align_center justify_center pt50 pb50">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="filter.total"
              :current-page="filter.Page"
              :page-size="filter.PageSize"
              @current-change="handleCurrentPage">
            </el-pagination>
            <!-- <div class="pages-btn df align_center justify_center">
              <img src="@/assets/images/pages-lt.png" class="db" alt="" />
            </div>
            <div class="pages-item df align_center justify_center">
              <router-link to="/" class="pages-box df align_center justify_center">1</router-link>
              <router-link to="/" class="pages-box df align_center justify_center">2</router-link>
              <router-link to="/" class="pages-box df align_center justify_center">3</router-link>
              <router-link to="/" class="pages-box df align_center justify_center">4</router-link>
              <router-link to="/" class="pages-box df align_center justify_center">5</router-link>
              <router-link to="/" class="pages-box df align_center justify_center">6</router-link>
              <router-link to="/" class="pages-box df align_center justify_center">7</router-link>
              <router-link to="/" class="pages-box df align_center justify_center">8</router-link>
            </div>
            <div class="pages-btn df align_center justify_center">
              <img src="@/assets/images/pages-rt.png" class="db" alt="" />
            </div> -->
          </div>
        </div>
        <div class="wz-gonglue-cate">
          <div class=" bgwh box-border pd20">
            <div class="f20 b tc">时间筛选</div>
            <div class="df align_center justify_center f16 wz-gonglue-cate-box" style="cursor:pointer" @click="handleRange(0)" :class="timeSelect == 0 ? 'foy' : ''">
              <div>&lt;&lt;&nbsp;</div>
              <div>全部</div>
              <div>&nbsp;&gt;&gt;</div>
            </div>
            <div class="df align_center justify_center f16 wz-gonglue-cate-box" style="cursor:pointer" @click="handleRange(1)" :class="timeSelect == 1 ? 'foy' : ''">
              <div>近一月</div>
            </div>
            <div class="df align_center justify_center f16 wz-gonglue-cate-box" style="cursor:pointer" @click="handleRange(2)" :class="timeSelect == 2 ? 'foy' : ''">
              <div>{{new Date().getFullYear()}}年</div>
            </div>
            <div class="df align_center justify_center f16 wz-gonglue-cate-box" style="cursor:pointer" @click="handleRange(3)" :class="timeSelect == 3 ? 'foy' : ''">
              <div>{{new Date().getFullYear() - 1}}年</div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import paramService from '@/services/client/option/params'
import strategyService from '@/services/client/cont/strategy'
import utils,{dateFormaOptions, dateFormaOptionsSimple} from '@/libs/utils'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      paramCode: 'cont_tag_series',
      paramChildCode: '230',
      seriesList: null,
      seriesSelect: null,
      filter: {
        Page: 1,
        PageSize: 10,
        beginTime: null,
        endTime: null,
        Series: '游客游记',
        total: 0,
      },
      list: null,
      timeSelect: 0,
    }
  },
  components: { Header, Bottom,},
  mounted() {
    this.loadData();
  },
  methods:{
    loadParam() {
      this.seriesList = null;
      paramService.detail(this.paramCode, this.paramChildCode).then(res => {
        if(res.Code == 200 && res.Data && res.Data.length > 0) {
          this.seriesList = res.Data;
          if(!this.seriesSelect) {
            this.filter.Series = res.Data[0].ValidValue;
            this.seriesSelect = res.Data[0].Code;
          }

          this.loadData();
        }
      })
    },
    loadData() {
      this.list = null;
      strategyService.list(this.filter).then(res => {
        if(res.Code == 200 && res.Data) {
          const data = res.Data;

          this.filter.total = data.Count;
          this.list = data.List;
        }
      })
    },
    handleSeriesClick(item) {
      this.filter.Series = item.ValidValue;
      this.seriesSelect = item.Code;

      this.loadData();
    },
    handleCurrentPage(page) {
      this.filter.Page = page;

      this.loadData();
    },
    handleRange(idx){
      const date = new Date();
      this.filter.Page = 1;
      this.timeSelect = idx;
      if(idx == 0) {
        this.filter.beginTime = null;
        this.filter.endTime = null;
      }

      if(idx == 1) {
        this.filter.beginTime = utils.dateFormat(new Date(date.getFullYear(), date.getMonth() - 1, date.getDate() + 1), 'yyyy-MM-dd 00:00:00');
        this.filter.endTime = utils.dateFormat(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1), 'yyyy-MM-dd 23:59:59');

        console.log(date);
        console.log(date.getFullYear(), date.getMonth() + 1 - 1, date.getDate());
      }

      if(idx == 2) {
        this.filter.beginTime = utils.dateFormat(new Date(), 'yyyy-MM-dd 00:00:00', {simple:dateFormaOptionsSimple.yearStart});
        this.filter.endTime = utils.dateFormat(new Date(), 'yyyy-MM-dd 23:59:59',{simple:dateFormaOptionsSimple.yeasEnd});
      }

      if(idx == 3) {
        this.filter.beginTime = utils.dateFormat(new Date(), 'yyyy-MM-dd 00:00:00', {simple:dateFormaOptionsSimple.yearStart, addYear: -1});
        this.filter.endTime = utils.dateFormat(new Date(), 'yyyy-MM-dd 23:59:59',{simple:dateFormaOptionsSimple.yeasEnd, addYear: -1});
      }

      this.loadData();
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/views/wanzhuan/gonglue.vue